import React, { useState } from "react";
import Logo from "../assets/Logo.png";
import { headerLinks } from "../utils";
import { HiMenuAlt3 } from "react-icons/hi";

import Button from "./Button";
const Header = ({ connectHandler }) => {
  const [active, setActive] = useState(false);
  return (
    <div>
      <div className="mx-auto max-w-[1300px] py-6 relative z-10">
        <div className="flex justify-between items-center py-4 bg-[#000] bg-opacity-20 px-4 rounded-lg">
          <div className="w-[60px]">
            <img src={Logo} alt="" />
          </div>
          <div className=" hidden md:grid grid-flow-col gap-4">
            <ul className=" hidden md:flex justify-center text-white font-medium font-serif">
              {headerLinks.map((val, i) => (
                <li key={i} className="p-2 px-6">
                  <a href={val.link}>{val.text}</a>
                </li>
              ))}
            </ul>
            <Button
              link
              href={
                "https://app.uniswap.org/#/swap?outputCurrency=0xA1B26B9918b350e9657D9Ab43A45088805d65E4e"
              }
            >
              Buy Now
            </Button>
          </div>
          <button
            className="md:hidden text-2xl"
            onClick={() => setActive((prev) => !prev)}
          >
            <HiMenuAlt3 />
          </button>
          <div
            className={`md:hidden fixed top-[130px] overflow-hidden left-[2%] w-[96%] transition-all duration-500 bg-[#1C1C1C] z-100 rounded-lg ${
              active ? "max-h-[100vh]" : "max-h-[0]"
            } `}
          >
            <div className="py-10">
              <ul className=" text-center text-gray font-medium font-serif">
                {headerLinks.map((val, i) => (
                  <li key={i} className="p-2 px-4">
                    <a
                      href={val.link}
                      onClick={() => setTimeout(() => setActive(false), 100)}
                    >
                      {val.text}
                    </a>
                  </li>
                ))}
              </ul>
              <div className=" mx-auto grid gap-4 justify-center">
                <Button
                  link
                  href={
                    "https://app.uniswap.org/#/swap?outputCurrency=0xA1B26B9918b350e9657D9Ab43A45088805d65E4e"
                  }
                >
                  Buy Now
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
